import { render, staticRenderFns } from "./AreaSelectModal.vue?vue&type=template&id=8a6a5010&"
import script from "./AreaSelectModal.vue?vue&type=script&lang=js&"
export * from "./AreaSelectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports